import React, { forwardRef } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'destructive';
  size?: 'sm' | 'md' | 'lg' | 'icon';
  isLoading?: boolean;
}
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  asChild = false,
  isLoading,
  children,
  ...props
}, ref) => {
  const Comp = asChild ? Slot : 'button';
  const variants = {
    primary: 'bg-[#218080] text-white hover:bg-[#1a6666] shadow-sm',
    secondary: 'bg-amber-100 text-amber-900 hover:bg-amber-200',
    outline: 'border border-slate-200 bg-white hover:bg-slate-100 text-slate-900',
    ghost: 'hover:bg-slate-100 text-slate-700',
    destructive: 'bg-red-500 text-white hover:bg-red-600'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 py-2',
    lg: 'h-12 px-8 text-lg',
    icon: 'h-10 w-10'
  };
  return <Comp className={cn('inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#218080] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', variants[variant], sizes[size], className)} ref={ref} disabled={isLoading || props.disabled} {...props} data-id="element-266">
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-267" />}
        {children}
      </Comp>;
});
Button.displayName = 'Button';
export { Button };